import React from 'react';

export const HiddenInputField = ({ input }) => (
    <input className="sd-line-input__input" type='hidden' {...input} />
);
